import { CoreGlobalFooter } from '@care/navigation';
import { type SegmentationListingPageProps } from '@/components/feature/searchDirectory/SearchDirectoryProps';
import { SearchDirectoryDataProvider } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { InternalLinkingSection } from '@/components/feature/searchDirectory/InternalLinkingSection';
import { BreadcrumbsSection } from '@/components/feature/searchDirectory/BreadcrumbsSection';
import { ArticleSection } from '@/components/common/ArticleSection/ArticleSection';
import { getArticlesList } from '@/helpers/getArticlesList';
import { ReviewsSection } from '@/components/feature/searchDirectory/ReviewsSection/ReviewsSection';
import { FAQSection } from '@/components/feature/searchDirectory/FAQSection';
import { HeroSection } from './components/section/HeroSection';
import { SearchResultsWithAsideSection } from './components/section/SearchResultsWithAsideSection';

export const SMBSearchDirectory = ({ pageData }: SegmentationListingPageProps) => {
  const articlesList = getArticlesList(pageData.seoArticlesList);

  return (
    <SearchDirectoryDataProvider pageData={pageData}>
      <HeroSection />
      <ReviewsSection searchDirectoryTemplateType="SMB" />
      <SearchResultsWithAsideSection />
      <FAQSection />
      <ArticleSection articles={articlesList} />
      <InternalLinkingSection />
      <BreadcrumbsSection />
      <CoreGlobalFooter variant="inverse" />
    </SearchDirectoryDataProvider>
  );
};

export default SMBSearchDirectory;
